import { Tooltip, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import * as S from './DealRoomMessageCard.styles';
import { IDealRoomShare } from '@app/interfaces/deal-room';
import editImg from 'assets/images/edit.svg';
import { updateDealRoomInfoOpening } from '@app/api/deal-room-info.api';
import { notificationController } from '@app/controllers/notificationController';
import { htmlConverter } from '@app/utils/utils';
import { TextEditor } from '@app/components/common/TextEditor/TextEditor';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@app/components/common/Spinner/Spinner';

const { Title } = Typography;

interface DealRoomMessageCardProps {
  dealRoom: IDealRoomShare;
  isAdmin?: boolean;
}

const DealRoomMessageCard: React.FC<DealRoomMessageCardProps> = ({ dealRoom, isAdmin }) => {
  const { t } = useTranslation();
  const [opening, setOpening] = useState<string>('');
  const [loader, setLoader] = useState(false);
  const [editOpening, setEditOpening] = useState(false);

  const onSaveOpening = async () => {
    setLoader(true);
    try {
      await updateDealRoomInfoOpening(dealRoom.id as string, opening);
      setEditOpening(false);
    } catch (error) {
      notificationController.error({ message: (error as Error).message });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (dealRoom?.dealRoomInfo?.opening) {
      if (htmlConverter(dealRoom.dealRoomInfo.opening) === '<p><br></p>') {
        setOpening('');
        return;
      }
      setOpening(htmlConverter(`${dealRoom?.dealRoomInfo?.opening ?? ''}`));
    }
  }, [dealRoom?.dealRoomInfo?.opening]);

  return (
    <Spinner spinning={loader}>
      <S.Card>
        <S.Typography>
          {isAdmin && (
            <Title level={5} className="client-title">
              <Tooltip title={t('dealRooms.landing.edit')}>
                <img
                  src={editImg}
                  alt="Edit"
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditOpening(!editOpening);
                  }}
                />
              </Tooltip>
            </Title>
          )}

          {opening && !editOpening && <S.Content dangerouslySetInnerHTML={{ __html: opening }} />}
          {editOpening && (
            <>
              <TextEditor
                value={opening}
                placeholder={t('dealRooms.form.opening')}
                onChange={(value) => setOpening(value as string)}
              />
              <S.SaveButton type="primary" onClick={onSaveOpening}>
                {t('common.save')}
              </S.SaveButton>
            </>
          )}
        </S.Typography>
      </S.Card>
    </Spinner>
  );
};

export default DealRoomMessageCard;
